import configureStore from '../../Foundation/Store/configureStore';

export const store = configureStore(); // redux